import { fetchFastApi } from "../../api/fastapi";
import { useHookCacheQuery } from "../../lib/hookCache";
import { AuditSession, sessionSchema } from "../../models/audit/auditSession";

/**
 * Hook for the new Phase 2 procedure-session full-hydration endpoint:
 * `GET /controls/v2/procedure-session/{id}`.
 *
 * Returns the same `AuditSession` (a.k.a. `Session`) shape as the legacy
 * megaquery's per-procedure node — useful for shimming Phase-3 components
 * that consume the full tree.
 */
export function useProcedureSession(procedureSessionId: string | undefined) {
  return useHookCacheQuery<AuditSession>({
    key: ["procedure-session", procedureSessionId ?? ""],
    fetcher: async () => {
      const response = await fetchFastApi({
        method: "GET",
        path: `/controls/v2/procedure-session/${procedureSessionId}`,
      });
      return sessionSchema.parse(response);
    },
    enabled: !!procedureSessionId,
  });
}
